













































































interface IfailData {
  failFileUrl: string;
  message: string;
  successNum?: number | null;
  failNum?: number | null;
}
import { setDeliverGoodsConfirm, getDeliverGoodsProgress } from '@/utils/api';
import { Vue, Component, Prop, PropSync, Emit, Ref } from 'vue-property-decorator';
@Component({ components: {} })
export default class DialogUpload extends Vue {
  @Ref('uploadFileRef') uploadFileRef!: any;
  @Prop({ default: '' }) action!: string;
  @Prop({ default: 1 }) limit!: number;
  @Prop({ default: false }) multiple!: boolean;
  @Prop({ default: '' }) tip!: string;
  @Prop({ default: true }) showTip!: boolean;
  @Prop({ default: '' }) downloadTemplateName!: string;
  @Prop({ default: '' }) downloadTemplateUrl!: string;
  @Prop({ default: '下载模板' }) downloadTemplateLabel!: string; //下载模板按钮 label
  @Prop({ default: () => [] }) warningList!: Array<string>; //注意事项

  // 弹窗部分属性设置
  @Prop({ default: '' }) title!: string;
  @Prop({ default: true }) closeOnClickModal!: boolean; //是否可以通过点击 modal 关闭 Dialog
  @Prop({ default: true }) closeOnPressEscape!: boolean; //是否可以通过按下 ESC 关闭 Dialog
  @Prop({ default: true }) showClose!: boolean; //是否显示关闭按钮
  @PropSync('visible', { type: Boolean }) syncVisible!: false;

  //确定 之后 显示 全屏 loading
  @Prop({ default: true }) fullscreenLoading!: boolean; //是否显示关闭按钮

  @Emit('onClose') onCloseEmit(msg?: any) {
    //关闭事件
    return msg;
  }
  @Emit('onConfirm') onConfirmEmit(msg?: any) {
    //确定事件
    return msg;
  }

  //导入成功
  @Emit('submitSuccess') submitSuccessEmit(msg?: any) {
    return msg;
  }

  dialogFormVisible: boolean = true;
  loading: boolean = false; //弹窗 loading

  originalFileUrl: string = '';
  originalFilename: string = '';

  confirmLoading: boolean = false;
  uploadHeaders: object = {}; //上传请求头

  // 发货失败
  failVisible: boolean = false;
  failData: IfailData = {
    failFileUrl: '',
    message: ''
  };
  /**
    点击取消
   */
  onClickOut(): void {
    this.onCloseEmit();
    this.syncVisible = false;
  }

  /**
    点击确认
   */
  onConfirm(): void {
    const { fullscreenLoading } = this;
    if (fullscreenLoading) {
      this.loading = true;
    } else {
      this.confirmLoading = true;
    }
    const { originalFileUrl, originalFilename } = this;
    setDeliverGoodsConfirm({ originalFileUrl, originalFilename }) //该接口暂时 写死 只针对 批量发货导入
      .then((res: any) => {
        console.log('res: 确认', res);
        this.getProgress();
        this.onConfirmEmit();
      })
      .catch(error => {
        console.error(error);
        this.$message.error(error);
      })
      .finally(() => {
        this.confirmLoading = false;
      });
  }

  // 查询导入进度
  getProgress() {
    getDeliverGoodsProgress()
      .then((res: any) => {
        switch (res.state) {
          case 'IN_PROGRESS': //进行中
            {
              setTimeout(() => {
                this.getProgress();
              }, 3000);
            }
            break;
          case 'FINISHED': //成功
            {
              this.showFailDialog(res);
            }
            break;
          case 'DATA_EXCEPTION': //失败   失败的时候 需要显示 失败原因 及 下载失败文件地址
            {
              this.showFailDialog(res);
            }
            break;
        }
      })
      .catch(err => {
        console.log('err: ', err);
      });
  }

  // 处理 查询进度 成功  或失败 及成功异常 显示 失败弹窗
  showFailDialog(data) {
    this.failData = data;
    this.loading = false;
    const { failFileUrl } = data;
    // const message = data?.message ?? '';
    if (failFileUrl) {
      // this.$message.success(message);
      this.clearFiles();
      this.failVisible = true;
      return;
    }
    this.$message.success('发货成功');
    this.submitSuccessEmit();
    this.syncVisible = false; //关闭弹窗
  }

  clearFiles() {
    this.uploadFileRef.clearFiles();
  }

  /**
    上传前校验
    @params file 文件对象
   */
  beforeUpload(file) {
    if (file.name.split('.')[0].length > 30) {
      this.$message.error('上传文件名称不能超过30个字!');
      return false;
    }
    const whiteList: Array<string> = ['xlsx', 'xls'];
    let idx: number = file.name.lastIndexOf('.');
    let suffix: string = idx < 1 ? '' : file.name.substr(idx + 1);
    if (!whiteList.includes(suffix)) {
      this.$message.error('上传文件只能是xls和xlsx格式!');
      return false;
    }
    return true;
  }

  /**
    上传和导入成功
    @params response 接口响应
    @params file 文件对象
    @params fileList 文件列表
   */
  onSuccess(response, file, fileList) {
    if (file.status === 'success') {
      this.originalFileUrl = response.originalFileUrl;
      this.originalFilename = response.originalFilename;
      this.$message.success('文件上传成功！');
    }
  }

  /**
    上传和导入失败
    @params response 接口响应
    @params file 文件对象
    @params fileList 文件列表
   */
  onError(response, file, fileList) {
    if (file.status === 'fail') {
      this.$message.error('上传失败,请重新上传！');
    }
  }

  /**
    下载模板
   */
  downloadTemplate() {
    const { downloadTemplateName, downloadTemplateUrl } = this;
    const aTag: HTMLAnchorElement = document.createElement('a');
    aTag.style.display = 'none';
    aTag.href = location.origin + '/' + downloadTemplateUrl;
    console.log('downloadTemplateUrl', location.origin + '/' + downloadTemplateUrl)
    aTag.download = downloadTemplateName;
    aTag.click();
    aTag.remove();
  }
  /**
    下载失败文件模板
   */
  downLoadFail() {
    const { failData } = this;
    const aTag: HTMLAnchorElement = document.createElement('a');
    aTag.style.display = 'none';
    aTag.href = failData.failFileUrl;
    aTag.download = '发货失败';
    aTag.click();
    aTag.remove();
  }

  //文件超出个数限制时的钩子
  onExceed(files, fileList) {
    const { limit } = this;
    if (files.length > limit) {
      this.$message.warning(`一次只能导入${limit}个表格！`);
    }
  }

  // 获取token
  getToken() {
    const authToken = localStorage.getItem('authToken');
    if (authToken) {
      this.uploadHeaders['Authorization'] = `Bearer ${authToken}`;
    }
  }

  openDialogEvent() {
    this.originalFileUrl = '';
    this.originalFilename = '';
    this.$nextTick(() => {
      this.clearFiles();
    });
  }

  closeDialogEvent() {
    this.clearFiles();
  }

  created() {
    const { getToken } = this;
    getToken();
  }
}
